/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
'use strict';
var searchPartMixin = require('../modules/mixins/searchpart.mixin');
var trackingUtils = require('../modules/utils/tracking.utils.js');
var searchChanges = require('../tracking/search_changes.js');
var mpiRoutes = require('../modules/enums/mpi_routes.enum');
var widget = Odigeo.Widget.extend({
    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
    },
    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        bindCustomEvents: function(searchModel) {
            this.searchModel = searchModel;
        },
        mpiRoutes: mpiRoutes,
    })),
    viewClass: Odigeo.View.extend({
        events: {
            'tap @searchButton': 'onClickSearch',
            'tap @editButton': 'onClickEdit',
        },

        selectors: {
            searchButton: '.oneline_search_button',
            editButton: '.oneline_search_button_change',
        },

        trackingMap: {
            'multipleTrip': 'multiple_destinations',
            'oneWayTrip': 'one_way',
            'roundTrip': 'return',
        },

        typeTrackingMap: {
            multipleTrip: 'MD',
            oneWayTrip: 'OW',
            roundTrip: 'RT',
        },

        init: function() {
            this.model.listenSearchModelProperty('editsearch', Odigeo._.bind(this.onEditSearchChange, this));
        },

        toggleElements: function(toggle) {
            this.$cachedSelectors.editButton.toggleClass('odf-hidden', toggle);
            this.$cachedSelectors.searchButton.toggleClass('odf-hidden', !toggle);
            this.model.set('editSearchOpen', toggle);
            this.model.setSearchModelProperty('editsearch', toggle);
            Odigeo.trigger(this.widget.id + ':editSearch', toggle);
        },

        onEditSearchChange: function(event, editSearch) {
            if (editSearch) {
                this.toggleElements(true);
            }
        },

        triggerSearchEventTracking: function(data) {
            trackingUtils.trackEvent('searcher_flights', 'search_' + this.trackingMap[data.type]);
        },

        trackingSearchEvents: function(data) {
            this.triggerSearchEventTracking(data);
            if (!Odigeo._.isUndefined(this.model.searchModel.get('lastSearch'))) {
                this.trackingDetailsSearch(this.model.searchModel.get('lastSearch'), data);
            }
        },

        getJsonRequestObject: function(data) {
            var requestData = Odigeo._.clone(data);
            if (requestData.type === 'oneWayTrip') {
                requestData.searchSegments = [requestData.searchSegments[0]];
            }
            return requestData;
        },

        onClickEdit: function() {
            this.toggleElements(true);
            if (this.model.searchModel.get('type') === 'multipleTrip') {
                var numLegs = this.model.searchModel.get('searchSegments').length;
                var maxLegs = this.widget.options.maxLegs;
                Odigeo.trigger('OneLinerMultiDestination:changeLegsMD', numLegs, numLegs < maxLegs);
            }
            this.model.setSearchModelProperty('editsearch', true);
            trackingUtils.trackEvent('searcher_flights', 'open_change_search_cta');
        },

        setForceResultsSearch: function() {
            if (this.model.searchModel.get('isInDetail')) {
                Odigeo.Session.set('setForceResultsPage', Odigeo.Utils.getSearchId());
            }
        },

        trackingDetailsSearch: function(lastSearch, currentSearch) {
            trackingUtils.trackEvent('searcher_flights', this.trackingDetailsSearchLabel(lastSearch, currentSearch));
        },

        trackingDetailsSearchLabel: function(lastSearch, currentSearch) {
            return searchChanges.changesInRequest(lastSearch, currentSearch);
        },

        trimSearchLegs: function(length) {
            var searchData = this.model.getOriginalData().searchSegments;
            searchData.length = length;
            this.model.setSearchModelProperty('searchSegments', searchData);
        },

        onClickSearch: function() {
            if (Odigeo.AB.isGoBackNativeMessage) {
                window.onbeforeunload = null;
            }
            var requestObject;
            var searchType = this.model.getOriginalData().type;
            this.model.setSearchModelProperty('searchSubmit', true);
            this.model.setSearchModelProperty('isInspirationalSearch', false);
            this.model.searchModel.trigger('submit');

            if (!Odigeo._.isEmpty(this.model.getErrors()) && this.model.searchModel.isSingleFlight()) {
                this.trimSearchLegs(searchType === 'oneWayTrip' ? 1 : 2);
            }

            if (Odigeo._.isEmpty(this.model.getErrors())) {
                this.trackingSearchEvents(this.model.getOriginalData());
                this.setForceResultsSearch();
                this.activateSearch();
                requestObject = this.getJsonRequestObject(this.model.getOriginalData());
                if (Odigeo.History.getPageNameFromFragment() === 'details') {
                    requestObject.comesFromPassenger = true;
                }
                var searchSegments = this.model.searchModel.get('searchSegments');
                var firstSegment = Odigeo._.first(searchSegments);
                var departureIATA = !Odigeo._.isUndefined(firstSegment) ? firstSegment.departure.iata : '';
                var destinationIATA = !Odigeo._.isUndefined(firstSegment) ? firstSegment.destination.iata : '';
                if (Odigeo.AB.isMPIRouteDesktop && this.isMPIRoute(departureIATA, destinationIATA)) {
                    this.setMPISessionValues(departureIATA, destinationIATA);
                }
                requestObject.externalSelectionRequest = {};
                Odigeo.trigger(this.widget.id + ':search', requestObject);
            }
        },

        isMPIRoute: function(departureIATA, destinationIATA) {
            return this.existsDepartureAndDestination(departureIATA, destinationIATA) && this.existsSegmentInMPIList(departureIATA, destinationIATA);
        },

        setMPISessionValues: function(departureIATA, destinationIATA) {
            Odigeo.Storage.set('mpiRouteStartSearch', Date.now());
            Odigeo.Storage.set('departureIATA', departureIATA);
            Odigeo.Storage.set('destinationIATA', destinationIATA);
        },

        existsDepartureAndDestination: function(departureIATA, destinationIATA) {
            return !Odigeo._.isEmpty(departureIATA) && !Odigeo._.isEmpty(destinationIATA);
        },

        existsSegmentInMPIList: function(departureIATA, destinationIATA) {
            var segment = departureIATA + '-' + destinationIATA;
            return Odigeo._.contains(this.model.mpiRoutes, segment);
        },

        activateSearch: function() {
            Odigeo.trigger(this.widget.id + ':activatedSearchClick');
            if (!this.widget.options.activateSearch) {
                this.toggleElements(false);
            } else {
                Odigeo.trigger(this.widget.id + ':toggleChangeSearch', true);
            }
        },
    }),

    changeVisibility: function() {
        this.view.onClickEdit();
    },
});

Odigeo.defineWidget('onelinebutton_search_manager', widget);
module.exports = widget;
